import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cartVersion: 0,
  totalCartCount: null,
  cartPreAddedDate: "",
  isCartLoaded: false,
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    bumpCartVersion: (state) => {
      state.cartVersion += 1;
    },
    getTotalCartCount: (state, action) => {
      state.totalCartCount = action.payload;
      state.isCartLoaded = true;
    },
    getCartPreviousAddedDate: (state, action) => {
      state.cartPreAddedDate = action.payload;
    },
  },
});

export const { bumpCartVersion, getTotalCartCount, getCartPreviousAddedDate } =
  orderSlice.actions;

export default orderSlice.reducer;
